/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Reward } from '../../models/reward';
import { UpdateRewardDto } from '../../models/update-reward-dto';

export interface RewardsControllerUpdate$Params {
  id: string;
      body: UpdateRewardDto
}

export function rewardsControllerUpdate(http: HttpClient, rootUrl: string, params: RewardsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
  const rb = new RequestBuilder(rootUrl, rewardsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Reward>;
    })
  );
}

rewardsControllerUpdate.PATH = '/rewards/{id}';
